module.exports = __webpack_public_path__ + "img/title.fb5a46c1.png";